module.exports = __webpack_public_path__ + "static/housing-b12b89001903bca454fc68ef200a73f1.png";